import type { Rule } from 'antd/es/form';

/** Required text field that also rejects whitespace-only input. ENMON-3876. */
export const requiredTextRule: Rule = { required: true, whitespace: true };
